import axios from 'axios'
import apiMonitorHelper from '@lib/business/apiMonitorHelper.js'

export function upload(file) {
  const formData = new FormData()
  formData.append('fileData', file.blob, file.name)
  formData.append('subfolder', 'feccms')
  return axios({
    method: 'post',
    url: `${process.env.VUE_APP_UPLOAD_TUJIA_HOST}/FileUpload.ashx`,
    data: formData,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    }
  }).then((ret) => {
    if (ret.status === 200) {
      apiMonitorHelper.apiMonitor(`${process.env.VUE_APP_UPLOAD_TUJIA_HOST}/FileUpload.ashx`, ret, ret.errcode || 'cms-upload-file-error')
      return Promise.resolve(process.env.VUE_APP_PIC_TUJIA_HOST + ret.data.msg.url)
    } else {
      return Promise.resolve(null)
    }
  })
}
